export default {
  API_URL: 'https://api.onde-encontrar.ceramicaderosso.com.br/',
  GRANT_TYPE: 'password',
  CLIENT_ID: '2',
  CLIENT_SECRET: 'sgrKIpCpJXsn4ZBTRsdpFRNnwkzl4kLxrC8nkyo5',
  UPLOAD_LIMIT: 5,
  GOOGLE_API_KEY: 'AIzaSyA2WbyBF5kc5Q8XcK8ZRFnAHFA-CHP5KYs',
};
